/*
 * Authenticator.jsx 05.12.2017
 *
 * (c) 2017 ergovia GmbH
 */

/**
 * Container für die Authentifizierung. Handled die Stateänderungen und Actions
 */

import Login from '../../components/core/Login';
import {connect} from 'react-redux';
import {refreshLogin } from '../../actions/actions';

const mapDispatchToProps = { refreshLogin };

const mapStateTopProps = state => ({
    user: state.authentication
});



export default connect(mapStateTopProps, mapDispatchToProps)(Login);



// WEBPACK FOOTER //
// ./src/de/ergovia/containers/core/Authenticator.js